
if (module.hot) {
    module.hot.accept();
    console.log('✅ HMR is working');
}